import React from 'react';
import { IItemForGetShortInfo, IItemForGetShortDishInfo } from 'types';
import { AdditionalDishMultipleSelect } from './components/AdditionalDishMultipleSelect';
import { DnDList } from './components/DnDList';
import style from './index.module.scss';

interface IProps {
	setFetchedAdditionalDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	setFetchedAdditionalDishes: (value: IItemForGetShortInfo[]) => void;
	setAdditionalDishCategory: (value: Nullable<string>) => void;
	setAdditionalDishSubCategory: (value: Nullable<string>) => void;
	setAdditionalDishes: (value: string[]) => void;
	removeAdditionalDish: (value: string) => void;
	IDsSelectedRestaurant: string[];
	selectedAdditionalDishCategory: Nullable<string>;
	selectedAdditionalDishSubCategory: Nullable<string>;
	selectedAdditionalDishes: string[];
	fetchedAdditionalDishes: IItemForGetShortDishInfo[];
}

export const AdditionalDishesField: React.FC<IProps> = React.memo(
	({
		setFetchedAdditionalDishSubCategories,
		setFetchedAdditionalDishes,
		setAdditionalDishCategory,
		setAdditionalDishSubCategory,
		setAdditionalDishes,
		removeAdditionalDish,
		IDsSelectedRestaurant,
		selectedAdditionalDishCategory,
		selectedAdditionalDishSubCategory,
		selectedAdditionalDishes,
		fetchedAdditionalDishes,
	}) => {
		return (
			<div className={style.container} data-test="AdditionalDishesField">
				<AdditionalDishMultipleSelect
					setFetchedAdditionalDishSubCategories={setFetchedAdditionalDishSubCategories}
					setFetchedAdditionalDishes={setFetchedAdditionalDishes}
					setAdditionalDishCategory={setAdditionalDishCategory}
					setAdditionalDishSubCategory={setAdditionalDishSubCategory}
					setAdditionalDishes={setAdditionalDishes}
					removeAdditionalDish={removeAdditionalDish}
					IDsSelectedRestaurant={IDsSelectedRestaurant}
					selectedAdditionalDishCategory={selectedAdditionalDishCategory}
					selectedAdditionalDishSubCategory={selectedAdditionalDishSubCategory}
					fetchedAdditionalDishes={fetchedAdditionalDishes}
					selectedAdditionalDishes={selectedAdditionalDishes}
				/>
				<DnDList
					selectedAdditionalDishes={selectedAdditionalDishes}
					fetchedAdditionalDishes={fetchedAdditionalDishes}
					setAdditionalDishes={setAdditionalDishes}
					removeAdditionalDish={removeAdditionalDish}
				/>
			</div>
		);
	},
);
